import '../css/welcome.css';

export default function Welcome() {
  return (
    <div className="home-wrapper">
      <h1 style={{ color: "red" }}>This is a personal project for learning purpose</h1>
      <h1>No more struggles.
        Plus de luttes.</h1>
      <h1>
        Find the best financial product fit. Start exploring with Monetary Canada today.
      </h1>
    </div>
  );
}


